import { Term } from '@platform-frontend/checkout-drop-in';

export interface OneTimePurchaseKind<T = Term> {
  type: 'ONE_TIME_PURCHASE';
  term: T;
}
